import React, { useState, useEffect } from 'react';
import { Segment, Header, List, Button, Grid } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { loggedIn, NextGatherInfoUrl } from 'dsoa-components';
import { courseCanEnroll, courseEnroll } from 'dsoapi';
import { useNavigate } from 'react-router-dom';
import './HomeCourse.css';

const HomeCourse = ({
  abbreviation = 'BDI',
  title = '4 Hour BDI/TCAC Online (Basic Driver Improvement) - $18.00',
  description = '',
  features = ['bullet 1', 'bullet 2', 'bullet 3'],
  boldFeatures = [2, 3],
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isEnrolling, setIsEnrolling] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleEnrollClick = async () => {
    if (!loggedIn()) {
      localStorage.setItem('signupCourse', abbreviation);
      navigate('/signup');
      return;
    } else {
      // logged in
      if (isEnrolling) {
        return;
      }
      setIsEnrolling(true);
      const canEnrollRes = await courseCanEnroll(abbreviation);
      if (canEnrollRes.data.canEnroll) {
        const enrollRes = await courseEnroll(abbreviation, {
          siteRegisteredWith: 'fedsafe',
        });
        const url = await NextGatherInfoUrl(
          enrollRes.data.userCourseEnrollmentId
        );
        navigate(url);
      } else {
        setIsEnrolling(false);
        navigate('/dashboard');
      }
    }
  };

  return (
    <div className="home-course-segment">
      <Header as="h4" attached="top" className="home-course-header">
        <strong>{title}</strong>
      </Header>
      <Segment attached className="home-course-body">
        {description && (
          <p
            className="home-course-description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        <List bulleted>
          {features.map((feature, index) => (
            <List.Item key={index}>
              {boldFeatures.includes(index) ? (
                <strong dangerouslySetInnerHTML={{ __html: feature }} />
              ) : (
                <span dangerouslySetInnerHTML={{ __html: feature }} />
              )}
            </List.Item>
          ))}
        </List>

        <Grid>
          {!isMobile ? (
            // For medium and larger screens - buttons on the right
            <Grid.Row>
              <Grid.Column textAlign="right">
                <Button
                  primary
                  className="home-course-button"
                  onClick={handleEnrollClick}
                >
                  Enroll For Online
                </Button>
                <Button
                  as={Link}
                  to={`/course/${abbreviation}`}
                  primary
                  className="home-course-button"
                >
                  Learn More
                </Button>
              </Grid.Column>
            </Grid.Row>
          ) : (
            // For mobile screens - stacked buttons
            <Grid.Row>
              <Grid.Column textAlign="center">
                <Button
                  primary
                  fluid
                  className="home-course-button-mobile"
                  onClick={handleEnrollClick}
                >
                  Enroll For Online
                </Button>
                <Button
                  as={Link}
                  to={`/course/${abbreviation}`}
                  primary
                  fluid
                  className="home-course-button-mobile"
                >
                  Learn More
                </Button>
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid>
      </Segment>
    </div>
  );
};

export default HomeCourse;
